document.addEventListener("DOMContentLoaded", function () {
  const cards = document.querySelectorAll(".card--alt4");

  cards.forEach(function (card) {
    card.addEventListener("click", function () {
      const link = card.querySelector("a");
      if (link && link.href) {
        window.location.href = link.href;
      }
    });
  });
});
